<template>
    <div class="facet">
        <div class="facet-header d-flex justify-content-between">
            <b-link class="facet-label" @click="collapseToggle">
                <slot name="facetLabel">{{ title }}</slot>
            </b-link>
            <div v-if="!hideCollapsibleButton" class="d-flex">
                <b-link class="collapse-icon" @click="collapseToggle">
                    <i class="material-icons">
                        {{
                            collapsed
                                ? "keyboard_arrow_down"
                                : "keyboard_arrow_up"
                        }}
                    </i>
                </b-link>
            </div>
        </div>
        <b-collapse class="facet-body" :visible="!collapsed">
            <slot />
        </b-collapse>
        <div v-if="!hideBottomBorder" class="d-flex flex-row-reverse">
            <div class="bottom-border"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FacetTemplate",
    props: {
        title: {
            type: String,
            default: "Example Title",
        },
        hideCollapsibleButton: {
            type: Boolean,
            default: false,
            required: false,
        },
        hideBottomBorder: {
            type: Boolean,
            required: false,
            default: false,
        },
        expandCollapse: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return { 
            collapsed: this.title.includes("Selected Filters")? this.expandCollapse === true: this.expandCollapse === false,
        };
    },
    methods: {
        collapseToggle() {
            this.collapsed = !this.collapsed;
        },
    },
};
</script>

<style lang="scss">
$medium-gray: #4a4a4a;
$muted-dark-gray: #888;
$muted-gray: #ddd;
$primary-blue: #007dc6;

.facet {
    margin-top: 5px;
    overflow: auto;

    .collapse-icon {
        margin-left: 10px;

        i {
            font-size: 30px;
            font-weight: bold;
            margin: -5px -5px 0;
        }
    }

    .bottom-border {
        background: #eee;
        height: 1px;
        width: 100%;

        @media (min-width: 576px) {
            background: linear-gradient(90deg, #ffffff 0%, #d8d8d8 100%);
            max-width: 178px;
        }
    }

    .facet-header {
        padding-right: 15px;
        .facet-label {
            width: 100%;
            color: $medium-gray;
            line-height: 20px;
            font-size: 16px;

            &:hover {
                text-decoration: none;
            }
        }
    }
    .facet-body {
        padding-right: 15px;
        padding-bottom: 10px;
    }

    > div {
        margin-top: 5px;

        ul {
            list-style: none;
            padding-left: 0;
        }
    }
}
</style>
